import { http } from "../../../common/http";
import { RegistrationParam } from "../param/registration.param";

class RegistrationService {

	add = (data: RegistrationParam) => {
		return http({
			method: "POST",
			url: `/registration`,
			data
		});
	};
}
export default new RegistrationService();
